import Checkout from "../features/checkout/Checkout";
export default function CheckoutPage() {
  return <Checkout />;
}
